import { render } from "./Create.vue?vue&type=template&id=c73d5290"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=c73d5290&lang=css"

import exportComponent from "/home/dyam/Documentos/RAREZA/mi-stock-rareza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__